import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
  Suspense,
} from 'react';
import styles from './AddSeatKeyboard.module.scss';
import cn from 'classnames';
import CustomKeyboard from '@components/KeyboardV2';
import { isEmpty } from 'lodash';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import Loader from '@components/common/Loader/newLoaderModal';
import { CUSTOM_MESSAGES } from '@veriables';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addInProcessItemsToCart } from '../../../MenuOrderHandler';
import filter from 'lodash/filter';
import find from 'lodash/find';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { setPosition, updateSeatInfo } from '@reducers/orders';
import { occupySeat } from '@reducers/checks';
import { setErrorPopUp } from '@reducers/notification';
import { sort } from '@utility/helperFunction';
import { safeJsonParse } from '@utility/helperFunction';

const BUTTON_THEME = {
  '{done}': { class: 'bgGreen' },
};

const AddSeatKeyboard = ({
  type,
  maxLength,
  isAlpha,
  name,
  placeholder,
  isOpen,
  specialValue,
  buttonName,
  check,
  serverAppTheme,
  screenType,
  cancelBtnName,
  onCancel,
  cart,
  deviceInfo,
  userInfo,
  setPosition,
  updateSeatInfo,
  occupySeat,
  setErrorPopUp,
  loading,
}) => {
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [inputs, setInputs] = useState({
    [name]: specialValue,
  });
  const [inputName, setInputName] = useState(name);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [error, setError] = useState({});

  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;


  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  const onSubmit = val => {
    const seatArray = [];
    if (Array.isArray(val)) {
      val.forEach(e => {
        seatArray.push({
          number: e, //changed position to number
          tableShareType: 0,
        });
      });
    } else {
      seatArray.push({
        number: val, //changed position to number
        tableShareType: 0,
      });
    }
    const cb = () => {
      const dataToSend = {
        storeId: deviceInfo?.storeId,
        deviceId: deviceInfo?.deviceId,
        employeeId: Number(userInfo?.id),
        employeeCard: userInfo?.employeeCard,
        checkHeaderId: check?.id,
        seats: seatArray,
      };
      occupySeat(dataToSend)
        .then(response => {
          updateChecksAfterResponse(response);
          const seatsData = filter(response.seats, seat => seat.open);
          const positionReq = find(
            seatsData,
            seat => seat.number === Number(dataToSend?.seats[0]?.number) //changed seat.position to seat.number
          );
          const seatReq = {
            ...response,
            seats: sort(response.seats, 'number'),
          };
          setPosition(positionReq);
          updateSeatInfo(seatReq);
          onCancel();
        })
        .catch(err => {
          setErrorPopUp({
            res: err.message,
          });
        });
    };
    addInProcessItemsToCart(cb, cart);
  };

  const onClickBtn = useCallback(e => {
    setError({});
    setSelectedSeats([]);
    const currentInputName = inputNameRef.current;
    setInputs(prev => ({
      ...prev,
      [currentInputName]: e === '{bksp}'
        ? prev[currentInputName]?.slice(0, -1)
        : (prev[currentInputName] ? prev[currentInputName].concat(e) : ''.concat(e)),
    }));
  }, []);

  const handleSetInputEmpty = useCallback(() => {
    const currentInputName = inputNameRef.current;
    setInputs(prev => ({ ...prev, [currentInputName]: '' }));
  }, []);
  useLayoutEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(type === 'number' ? 'number' : type);
    }
  }, [type]);

  useLayoutEffect(() => {
    setInputs({
      ...inputs,
      [name]: specialValue,
    });
  }, [isOpen]);

  const setEmpty = data => {
    setInputs({
      ...inputs,
      [data]: '',
      error: '',
    });
  };
  const getInputValue = inputNameDat => {
    return inputs[inputNameDat] || '';
  };

  const submit = () => {
    onSubmit(selectedSeats.length > 0 ? selectedSeats : inputs[inputName]);
  };

  const validateSeatNumber = val => {
    if (selectedSeats.length > 0) {
      return submit();
    }
    const isSeat = safeJsonParse(
      window.sessionStorage.getItem('seat'),
      {}
    ).seats.find(item => item.open && item.number === Number(val));
    if (isEmpty(val)) {
      setError({
        ...error,
        seatNumber: `Select Seat ${name === 'seatName' ? 'Name' : 'Number'}`,
      });
    } else if (isSeat) {
      setErrorPopUp({
        res: 'Seat number already taken',
        noErrorTxt: true,
      });
    }
    return val && !isSeat && submit();
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const addRemoveSeats = node => {
    setError({ ...error, seatNumber: '' });
    if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
      setSelectedSeats([node]);
    } else if (
      selectedSeats.indexOf(node) === -1 &&
      !selectedSeats.includes('table')
    ) {
      setSelectedSeats(selectedSeats.concat(node));
    } else {
      setSelectedSeats(selectedSeats.filter(x => x !== node));
    }
    if (node === 'table') {
      setSelectedSeats(['table']);
    }
  };

  const [finatSeatArray, setFinalSeatArray] = useState();
  let seatArrays = [];
  const addSeatDynamically = () => {
    let count = 0;
    let seatCount = 1;
    while (count < 16) {
      if (
        check?.seats?.filter(e => e.open && e.number === seatCount).length === 0
      ) {
        seatArrays[count] = seatCount;
        count++;
        seatCount++;
      } else {
        seatCount++;
      }
    }
    return seatArrays;
  };
  useEffect(() => {
    let addedSeats = addSeatDynamically();
    setFinalSeatArray(addedSeats);
  }, []);

  const keyboardStyle = useMemo(() => {
    const wrapperStyle = {
      margin: '1rem auto',
    };
    const buttonContainer = { bottom: '30px', left: '0' };
    const submitButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
      height: '90%',
    };
    const cancelButton = {
      color: serverAppTheme?.cancleBtn_font,
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
    };

    return { wrapperStyle, buttonContainer, submitButton, cancelButton };
  }, [serverAppTheme, selectedSeats]);

  const handleAddSeatClick = () => {
    if (selectedSeats?.length === 0 && !inputs[inputName]) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().ADD_SEAT_ERROR,
        noErrorTxt: true,
        onClickChange: () => {},
      });
    } else {
      name === 'seatNumber'
        ? validateSeatNumber(getInputValue(name))
        : submit();
    }
  };

  return (
    <>
      <>{loading && <Loader />}</>
      <div
        className={cn(
          'col-12 px-0 pt-1 large-input  d-flex align-items-center justify-content-center  position-relative h-95'
        )}
      >
        <div className="col-12 px-0 h-100 position-relative">
          {check && (
            <div className={cn('col-12 px-0 w-100  h-18 pt-2')}>
              <div
                className={cn(
                  'col-12 row px-3 mx-0 my-0 flex-wrap w-100 pb-2',
                  styles.wrapper
                )}
                style={keyboardStyle.wrapperStyle}
              >
                {finatSeatArray?.map(item => {
                  return (
                    <TouchableDiv
                      key={item}
                      role="presentation"
                      onClick={() => {
                        addRemoveSeats(item);
                        setEmpty(name);
                      }}
                      className={cn(
                        styles.btnBorderWhite,
                        selectedSeats.length > 0 && selectedSeats.includes(item)
                          ? styles.selectedSeats
                          : `${styles.unSelectedSeats}`,
                        'd-flex justify-content-center align-items-center border rounded fs_16 w-100'
                      )}
                      style={{
                        color: selectedSeats?.includes(item)
                          ? '#000'
                          : serverAppTheme?.primary_text,
                        border: selectedSeats?.includes(item)
                          ? 'none'
                          : serverAppTheme?.popupBorder,
                        background: selectedSeats?.includes(item)
                          ? serverAppTheme?.selected
                          : serverAppTheme?.unselected,
                        height: '2rem',
                      }}
                    >
                      {item}
                    </TouchableDiv>
                  );
                })}
              </div>
            </div>
          )}
          <div
            className={cn(
              'col-12 px-3 position-relative',
              error?.seatNumber?.length > 0 ? 'h-15 py-1' : 'h-17 py-2'
            )}
          >
            <input
              id={name}
              type="text"
              name={name}
              className={cn(
                'col-12 p-2 fs_18 fw-400 text-left h-100',
                styles.inputFild
              )}
              style={{
                background: serverAppTheme?.inputBg,
                borderBottom: serverAppTheme?.inputBorder_Bottom,
                color: serverAppTheme?.primary_text,
              }}
              placeholder={placeholder}
              value={getInputValue(name)}
              onFocus={() => {
                handleBlur();
                setInputName(name);
                setKeyboardType(type);
              }}
            />
          </div>
          {error?.seatNumber?.length > 0 && (
            <div className="error fs_12 text-right px-3">
              {error.seatNumber}
            </div>
          )}
          {isSwipedDown && (
            <div>
              <CustomKeyboard
                setKeyboardType={setKeyboardType}
                onClickBtn={onClickBtn}
                type={keyboardType}
                closeKeyboard={closeKeyboard}
                customClass={`fs-30 p-1 pl-2`}
                maxLength={maxLength}
                buttonTheme={BUTTON_THEME}
                setinputEmpty={handleSetInputEmpty}
                screenType={screenType}
              />
            </div>
          )}
          <div
            style={keyboardStyle.buttonContainer}
            className={cn(
              'col-12 px-3 d-flex justify-content-center align-items-center w-100 position-absolute',
              error?.seatNumber?.length > 0 && 'pt-1'
            )}
          >
            <div className="col-4 pl-0 pr-1 h-100 d-flex align-items-end">
              <TouchableButton
                className={cn('w-100 btn-ripple rounded h-90')}
                type="button"
                onClick={e => {
                  onCancel();
                  e.preventDefault();
                }}
                style={keyboardStyle.cancelButton}
                rippleEffect={true}
              >
                <div className="fs_24 fw-600">{cancelBtnName}</div>
              </TouchableButton>
            </div>
            <div className="col-4 pl-1 pr-0 h-100 d-flex align-items-end">
              <TouchableButton
                className={cn('w-100 btn-ripple border-0 rounded')}
                type="button"
                onClick={e => {
                  handleAddSeatClick();
                  e.preventDefault();
                }}
                style={keyboardStyle.submitButton}
                rippleEffect={true}
              >
                <div className="fs_24 fw-600">{buttonName}</div>
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ orders, oauth, checks }) => ({
  check: orders.seats,
  cart: orders.cart,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  loading: checks.loading,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPosition,
      updateChecksAfterResponse,
      updateSeatInfo,
      occupySeat,
      setErrorPopUp,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddSeatKeyboard);
